import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbMarkdownTextEditor;
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbTextArea } from "abreact/input/AbTextArea";
import { AbMarkdownImageDialog } from "abreact/input/markdown/AbMarkdownImageDialog";
import { AbMarkdownLinkDialog } from "abreact/input/markdown/AbMarkdownLinkDialog";
import { AbToolbar } from "abreact/layout/toolbar/AbToolbar";
import { AbButton } from "abreact/misc/AbButton";
import { AbColorPicker } from "abreact/misc/AbColorPicker";
import { AbToggleButton } from "absdk/commons/ui/misc/AbToggleButton";
import React from "react";
import TextareaMarkdown from "textarea-markdown-editor";
import { isURL } from "textarea-markdown-editor/dist/utils";
export class AbMarkdownTextEditor extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "markdown", void 0);
    _defineProperty(this, "textareaMarkdownRef", void 0);
    _defineProperty(this, "textColor", "black");
    _defineProperty(this, "backgroundColor", "white");
    _defineProperty(this, "onChangeTextarea", text => {
      this.markdown = text;
      if (this.props.value !== this.markdown) {
        this.props.onChange(this.markdown);
      }
    });
    _defineProperty(this, "editLink", image => {
      const textAreaMarkdownRef = this.textareaMarkdownRef.current;
      if (textAreaMarkdownRef) {
        // Is cursor inside a link?  Popup the link dialog for it.
        const currentPosition = textAreaMarkdownRef.cursor.position;
        const currentColumn = currentPosition.cursorAt - currentPosition.line.startsAt; // where in the line is the cursor?
        const linkRegex = image ? RegExp(/!\[([^\]]*)]\(([^)]*)\)/, "g") : RegExp(/\[([^\]]*)]\(([^)]*)\)/, "g");
        let matched;
        while ((matched = linkRegex.exec(currentPosition.line.text)) !== null) {
          if (matched.index < currentColumn && matched.index + matched[0].length > currentColumn) {
            const text = matched[1];
            const url = matched[2];
            if (image) this.setState({
              showImageDialog: true,
              text,
              url
            });else this.setState({
              showLinkDialog: true,
              text,
              url
            });
            return;
          }
        }
        // if cursor is on an url, use that as both the selection and the text
        if (isURL(textAreaMarkdownRef.cursor.selection?.text)) {
          const linkText = textAreaMarkdownRef.cursor.selection.text;
          const MARKER = "\0";
          textAreaMarkdownRef.cursor.insert(`${image ? "!" : ""}[${MARKER}${linkText}${MARKER}](${linkText})`);
          return;
        }
        // otherwise, do what the textarea component says
        textAreaMarkdownRef.trigger(image ? "image" : "link");
      }
    });
    _defineProperty(this, "editImage", () => {
      this.editLink(true);
    });
    _defineProperty(this, "insertLink", (text, url, image) => {
      // Textarea editor showing, so cursor is on link to be replaced
      const textAreaMarkdownRef = this.textareaMarkdownRef.current;
      if (textAreaMarkdownRef) {
        const currentPosition = textAreaMarkdownRef.cursor.position;
        const currentColumn = currentPosition.cursorAt - currentPosition.line.startsAt; // where in the line is the cursor?
        const lineText = currentPosition.line.text;
        const linkRegex = image ? RegExp(/!\[[^\]]*]\([^)]*\)/, "g") : RegExp(/\[[^\]]*]\([^)]*\)/, "g");
        let matched;
        while ((matched = linkRegex.exec(lineText)) !== null) {
          if (matched.index < currentColumn && matched.index + matched[0].length > currentColumn) {
            let newLine;
            if (url.length === 0) {
              // empty url means remove the link
              newLine = lineText.slice(0, matched.index) + lineText.slice(matched.index + matched[0].length);
            } else {
              const newLink = `${image ? "!" : ""}[${text}](${url})`;
              newLine = lineText.slice(0, matched.index) + "\0" + newLink + "\0" + lineText.slice(matched.index + matched[0].length);
            }
            textAreaMarkdownRef.cursor.replaceLine(currentPosition.line.lineNumber, newLine);
            break;
          }
        }
      }
      return Promise.resolve(true);
    });
    _defineProperty(this, "insertImage", (text, url) => {
      return this.insertLink(text, url, true);
    });
    this.markdown = this.props.value;
    this.textareaMarkdownRef = /*#__PURE__*/React.createRef();
    AbMarkdownTextEditor.textareaMarkdownOptions.linkTextPlaceholder = AbReactResources.markdownEditor_textAreaLinkTextPlaceholder();
    AbMarkdownTextEditor.textareaMarkdownOptions.linkUrlPlaceholder = AbReactResources.markdownEditor_textAreaLinkUrlPlaceholder();
    AbMarkdownTextEditor.textareaMarkdownOptions.imageTextPlaceholder = AbReactResources.markdownEditor_textAreaImageTextPlaceholder();
    AbMarkdownTextEditor.textareaMarkdownOptions.imageUrlPlaceholder = AbReactResources.markdownEditor_textAreaImageUrlPlaceholder();
    this.state = {
      showLinkDialog: false,
      showImageDialog: false,
      text: "",
      url: ""
    };
  }
  textStyle(newStyle) {
    const textAreaMarkdownRef = this.textareaMarkdownRef.current;
    if (textAreaMarkdownRef) {
      textAreaMarkdownRef.trigger(AbMarkdownTextEditor.draftStyleToTextAreaMarkdown[newStyle]);
    }
  }
  textBlock(blockType) {
    const textAreaMarkdownRef = this.textareaMarkdownRef.current;
    if (textAreaMarkdownRef) {
      textAreaMarkdownRef.trigger(AbMarkdownTextEditor.draftBlockToTextAreaMarkdown[blockType]);
    }
  }
  colorPicked(newColor, colorOrBackground) {
    const textAreaMarkdownRef = this.textareaMarkdownRef.current;
    if (textAreaMarkdownRef) {
      const matches = newColor.match(/var\(--(ab-setting|hc)-color-(.*)\)/);
      if (matches) newColor = matches[2];
      textAreaMarkdownRef.trigger("color", newColor, colorOrBackground);
    }
  }
  renderToolbar() {
    return /*#__PURE__*/React.createElement(AbToolbar, {
      groups: [{
        items: [!this.props.disabledEditorTools?.bold && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_bold(),
          key: "bold",
          icon: "absdk:text-bold",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textStyle.bind(this, "BOLD")
        }), !this.props.disabledEditorTools?.italic && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_italic(),
          key: "italic",
          icon: "absdk:text-italic",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textStyle.bind(this, "ITALIC")
        }), !this.props.disabledEditorTools?.underline && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_underline(),
          key: "underline",
          icon: "absdk:text-underline",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textStyle.bind(this, "UNDERLINE")
        }), !this.props.disabledEditorTools?.strikeThrough && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_strikethrough(),
          icon: "absdk:text-strikethrough",
          key: "strikethrough",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textStyle.bind(this, "STRIKETHROUGH")
        }), !this.props.disabledEditorTools?.monospace && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_monospace(),
          icon: "absdk:text-monospace",
          key: "monospace",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textStyle.bind(this, "CODE")
        })]
      }, {
        items: [!this.props.disabledEditorTools?.bulleted && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_unorderedList(),
          icon: "absdk:list",
          key: "unorderedList",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textBlock.bind(this, "unordered-list-item")
        }), !this.props.disabledEditorTools?.numbered && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_orderedList(),
          icon: "absdk:list-numbered",
          key: "orderedlist",
          value: false,
          disabled: this.props.disabled,
          onChange: this.textBlock.bind(this, "ordered-list-item")
        })]
      }, {
        items: [!this.props.disabledEditorTools?.color && /*#__PURE__*/React.createElement(AbColorPicker, {
          icon: "absdk:text-color",
          tooltip: AbReactResources.markdownEditor_foregroundColorButton(),
          key: "color",
          value: this.textColor,
          show12Colors: true,
          disabled: this.props.disabled,
          onChange: newColor => {
            this.textColor = newColor;
            this.colorPicked(newColor, "color");
          }
        }), !this.props.disabledEditorTools?.background && /*#__PURE__*/React.createElement(AbColorPicker, {
          icon: "absdk:text-highlight",
          tooltip: AbReactResources.markdownEditor_backgroundColorButton(),
          key: "backgroundColor",
          value: this.backgroundColor,
          show12Colors: true,
          disabled: this.props.disabled,
          onChange: newColor => {
            this.backgroundColor = newColor;
            this.colorPicked(newColor, "background");
          }
        })]
      }, {
        items: [!this.props.disabledEditorTools?.link && /*#__PURE__*/React.createElement(AbButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_createLink(),
          key: "link",
          icon: "absdk:linked-item",
          disabled: this.props.disabled,
          onClick: () => this.editLink()
        }), !this.props.disabledEditorTools?.image && /*#__PURE__*/React.createElement(AbButton, {
          className: "abui ab-no-border-button",
          tooltip: AbReactResources.markdownEditor_createImage(),
          key: "image",
          icon: "absdk:photo",
          disabled: this.props.disabled,
          onClick: this.editImage
        })]
      }],
      fixedGroup: {
        items: [!this.props.disabledEditorTools?.textMode && /*#__PURE__*/React.createElement(AbToggleButton, {
          className: "abui ab-no-border-button",
          icon: "absdk:text-markdown",
          tooltip: AbReactResources.markdownEditor_editMarkdown(),
          key: "markdown",
          dataTestId: "edit-markdown-button",
          value: true // we know we're in Markdown text on this toolbar
          ,
          onChange: () => {
            this.props.onChange(this.markdown);
            this.props.setShowText(false);
          }
        })]
      }
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderToolbar(), /*#__PURE__*/React.createElement(TextareaMarkdown.Wrapper, {
      commands: AbMarkdownTextEditor.textareaMarkdownCommands,
      options: AbMarkdownTextEditor.textareaMarkdownOptions,
      ref: this.textareaMarkdownRef
    }, /*#__PURE__*/React.createElement(AbTextArea, {
      className: "ab-markdown-textarea",
      dataTestId: "edit-markdown-textarea",
      value: this.markdown,
      disabled: this.props.disabled,
      onChange: this.onChangeTextarea,
      autoFocus: true
    })), this.state?.showLinkDialog && /*#__PURE__*/React.createElement(AbMarkdownLinkDialog, {
      text: this.state.text,
      url: this.state.url,
      buttonEl: null,
      onOk: (text, url) => {
        return this.insertLink(text, url);
      },
      onClose: () => {
        this.setState({
          showLinkDialog: false
        });
      }
    }), this.state?.showImageDialog && /*#__PURE__*/React.createElement(AbMarkdownImageDialog, {
      alt: this.state.text,
      url: this.state.url,
      buttonEl: null,
      onOk: (text, url) => {
        return this.insertImage(text, url);
      },
      onClose: () => {
        this.setState({
          showImageDialog: false
        });
      }
    }));
  }
  componentDidUpdate() {
    if (this.markdown !== this.props.value) {
      this.markdown = this.props.value;
      this.forceUpdate();
    }
  }
}
_AbMarkdownTextEditor = AbMarkdownTextEditor;
_defineProperty(AbMarkdownTextEditor, "textareaMarkdownOptions", {
  preferredItalicSyntax: "_",
  boldPlaceholder: "",
  italicPlaceholder: "",
  strikeThroughPlaceholder: "",
  codeInlinePlaceholder: "",
  enableLinkPasteExtension: false
});
_defineProperty(AbMarkdownTextEditor, "draftStyleToTextAreaMarkdown", {
  "BOLD": "bold",
  "CODE": "code-inline",
  "ITALIC": "italic",
  "STRIKETHROUGH": "strike-through",
  "UNDERLINE": "underline"
});
_defineProperty(AbMarkdownTextEditor, "draftBlockToTextAreaMarkdown", {
  "unordered-list-item": "unordered-list",
  "ordered-list-item": "ordered-list",
  "code-block": "code-block"
});
_defineProperty(AbMarkdownTextEditor, "underlineHandler", ({
  cursor
}) => {
  cursor.wrap("++");
});
_defineProperty(AbMarkdownTextEditor, "colorHandler", ({
  cursor
}, newColor, colorOrBackground) => {
  cursor.wrap([`{${colorOrBackground}: ${newColor}}`, `{${colorOrBackground}}`]);
});
_defineProperty(AbMarkdownTextEditor, "textareaMarkdownCommands", [{
  name: "underline",
  handler: _AbMarkdownTextEditor.underlineHandler
}, {
  name: "color",
  handler: _AbMarkdownTextEditor.colorHandler
}]);
//# sourceMappingURL=AbMarkdownTextEditor.js.map
